export default __webpack_public_path__ + "static/media/icon_tabs_work_active.e629dba2.svg";